export default {
  id: 99,
  title: 'Target #99 - Gift Box',
  url: 'https://cssbattle.dev/play/99',
  colors: ['#AC474B', '#FFFFFF'],
  solution:
    '<a a><a b><a c><style>[b],[c]{top:50;width:20;height:20}body{background:#ac474b}a{position:fixed}[a]{top:110;left:130;width:60;height:60;background:#fff;box-shadow:80px 0 #fff,0 80px #fff,80px 80px #fff}[b]{left:165;border:10px solid #fff;border-radius:9in 9in 0}[c]{left:195;border:10px solid #fff;border-radius:9in 9in 9in 0}</style>',
}
